﻿import { api } from '@cwd/lib/main';

export async function countContacts(inactiveMonths: number): Promise<number> {
    return api.get('/datamanagement/countinactivecontacts?inactiveMonths=' + inactiveMonths);
}

export async function anonymizePeriod(inactiveMonths: number): Promise<void | Response> {
    return api.post('/datamanagement/anonymizeInactiveContacts?inactiveMonths=' + inactiveMonths);
}

export async function countDuplicates(): Promise<number> {
    return api.get('/datamanagement/CountDuplicateContacts');
}

export interface DuplicateContact {
    Email: string;
    Contacts: DuplicateContactSummary[];
}

export interface DuplicateContactSummary {
    ContactId: string;
    ExternalId: string;
    Email: string;
    SmsNumber: string;
    Created: Date;
    LastModified: Date;
}

const pageSize = 25;
export async function listDuplicates(skip: number, filterEmail: string): Promise<{ Count: number; Results: DuplicateContact[] }> {
    let searchString = '';
    !!filterEmail && (searchString = "&$filter=startswith(Email,'" + filterEmail + "')");
    return api.get('/datamanagement/DuplicateContacts?$inlinecount=allpages&$top=' + pageSize + '&$skip=' + skip + searchString);
}

export async function startDuplicateMerge(): Promise<void | Response> {
    return api.post('/datamanagement/MergeDuplicateContacts');
}

export async function mergeSingleContact(contact: DuplicateContact): Promise<void | Response> {
    return api.post('/datamanagement/MergeSingleContact', contact);
}
